import { useQuery } from "@tanstack/react-query";
import { DecentralizationGroupsService } from "../../../../../services/decentralization/decentralization.service";

export const useSettingsPermission = () => {
  const { data, ...rest } = useQuery({
    queryKey: ["settings-permission"],
    queryFn: () => DecentralizationGroupsService.getGroups(),
    staleTime: Infinity,
  });

  return { data, rest };
};
